var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRestaurantPizza40PxSelected = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "restaurant-pizza",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 58,
    viewBox: "0 0 40 58",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 55,
    r: 3,
    fill: "#FF2E00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,48,34.142,33.521a19.531,19.531,0,0,0,5.474-10.054,19.315,19.315,0,0,0-1.138-11.345,19.725,19.725,0,0,0-7.367-8.813,20.309,20.309,0,0,0-22.222,0,19.725,19.725,0,0,0-7.367,8.813A19.315,19.315,0,0,0,.384,23.467,19.531,19.531,0,0,0,5.858,33.521Z",
    fill: "#FF2E00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(12.5,12.5)",
    fill: "#ffffff",
    d: "M2.3926,8.9315,1.0245,8.3148A14.0478,14.0478,0,0,1,8.7637.9994l.027.07L9.3022,2.4l-.0037.0013a12.6131,12.6131,0,0,0-6.9057,6.53Zm10.9631,4.96L3.42,9.413a11.6038,11.6038,0,0,1,6.354-6.0088l.0033-.0013.8163,2.1222c-.0281-.0022-.0521-.0162-.0808-.0162a1.062,1.062,0,1,0,.7642,1.7932L13.69,13.575A.2487.2487,0,0,1,13.3557,13.891Zm-4.93-5.3727a.9245.9245,0,1,0-.9245.9244A.9245.9245,0,0,0,8.4255,8.5183Zm3.0169,2.03a.9252.9252,0,1,0-.9252.9252A.9252.9252,0,0,0,11.4424,10.5478Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRestaurantPizza40PxSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/restaurant-pizza_40px_selected.fbea904749cd0b55651f83aaed7aab38.svg";